import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';

export interface FileSpec {
  fieldName: string;
  label: string;
  formats?: string[];
  maxSize?: {
    value: number;
    unit: 'B' | 'kB' | 'MB';
  };
  resolution?: string;
  category?: 'web' | 'mimesys' | 'fitmade4u' | '360';
  type?: 'image' | 'video';
  min?: number;
  max?: number;
}

@Injectable({
  providedIn: 'root'
})
export class FileSpecsService {
  
  private specs: { [key: string]: FileSpec } = {
    // ========== SETTINGS WEB ==========
    'wallpaperImage': {
      fieldName: 'wallpaperImage',
      label: 'Wallpaper Image',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 1500, unit: 'kB' },
      resolution: '1920x1080 px',
      category: 'web',
      type: 'image'
    },
    'webLogo1': {
      fieldName: 'webLogo1',
      label: 'Logo 1',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 100, unit: 'kB' },
      resolution: '900x200 px',
      category: 'web',
      type: 'image'
    },
    'webLogo2': {
      fieldName: 'webLogo2',
      label: 'Logo 2',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 100, unit: 'kB' },
      resolution: '900x200 px',
      category: 'web',
      type: 'image'
    },
    'webLogo3': {
      fieldName: 'webLogo3',
      label: 'Logo 3',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 100, unit: 'kB' },
      resolution: '900x200 px',
      category: 'web',
      type: 'image'
    },
    'sidebarImage': {
      fieldName: 'sidebarImage',
      label: 'Sidebar image',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 1500, unit: 'kB' },
      resolution: '330x1080 px',
      category: 'web',
      type: 'image'
    },
    'webLogo4': {
      fieldName: 'webLogo4',
      label: 'Logo 4',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 100, unit: 'kB' },
      resolution: '900x200 px',
      category: 'web',
      type: 'image'
    },
    'webLogo5': {
      fieldName: 'webLogo5',
      label: 'Logo 5',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 100, unit: 'kB' },
      resolution: '900x200 px',
      category: 'web',
      type: 'image'
    },
    'webLogo6': {
      fieldName: 'webLogo6',
      label: 'Logo 6',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 100, unit: 'kB' },
      resolution: '900x200 px',
      category: 'web',
      type: 'image'
    },
    'logo4': {
      fieldName: 'logo4',
      label: 'Logo 4',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 100, unit: 'kB' },
      resolution: '900x200 px',
      category: 'web',
      type: 'image'
    },
    'logo5': {
      fieldName: 'logo5',
      label: 'Logo 5',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 100, unit: 'kB' },
      resolution: '900x200 px',
      category: 'web',
      type: 'image'
    },
    'logo6': {
      fieldName: 'logo6',
      label: 'Logo 6',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 100, unit: 'kB' },
      resolution: '900x200 px',
      category: 'web',
      type: 'image'
    },
    // Dashboard card header logos (900x200, per card) — PNG transparency preserved
    'dashboardCardMimesysHeaderLogo': {
      fieldName: 'dashboardCardMimesysHeaderLogo',
      label: 'Mimesys Card Header Logo',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 100, unit: 'kB' },
      resolution: '900x200 px',
      category: 'web',
      type: 'image'
    },
    'dashboardCardFitHeaderLogo': {
      fieldName: 'dashboardCardFitHeaderLogo',
      label: 'FIT Card Header Logo',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 100, unit: 'kB' },
      resolution: '900x200 px',
      category: 'web',
      type: 'image'
    },
    'dashboardCardDepict360HeaderLogo': {
      fieldName: 'dashboardCardDepict360HeaderLogo',
      label: '360Depict Card Header Logo',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 100, unit: 'kB' },
      resolution: '900x200 px',
      category: 'web',
      type: 'image'
    },
    // Dashboard card body images (800x480, per card) — PNG transparency preserved over gradient
    'dashboardCardMimesysBodyImage': {
      fieldName: 'dashboardCardMimesysBodyImage',
      label: 'Mimesys Card Body Image',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 300, unit: 'kB' },
      resolution: '800x480 px',
      category: 'web',
      type: 'image'
    },
    'dashboardCardFitBodyImage': {
      fieldName: 'dashboardCardFitBodyImage',
      label: 'FIT Card Body Image',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 300, unit: 'kB' },
      resolution: '800x480 px',
      category: 'web',
      type: 'image'
    },
    'dashboardCardDepict360BodyImage': {
      fieldName: 'dashboardCardDepict360BodyImage',
      label: '360Depict Card Body Image',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 300, unit: 'kB' },
      resolution: '800x480 px',
      category: 'web',
      type: 'image'
    },

    // ========== SETTINGS VR APP (MIMESYS) ==========
    'mimesysProductLogo': {
      fieldName: 'mimesysProductLogo',
      label: 'Product logo (B)',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 100, unit: 'kB' },
      resolution: '900x400 px',
      category: 'mimesys',
      type: 'image'
    },
    'lensLogo': {
      fieldName: 'lensLogo',
      label: 'Logo Lens (C)',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 100, unit: 'kB' },
      resolution: '900x200 px',
      category: 'mimesys',
      type: 'image'
    },
    'coachLogo': {
      fieldName: 'coachLogo',
      label: 'Coach Logo (D)',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 100, unit: 'kB' },
      resolution: '900x200 px',
      category: 'mimesys',
      type: 'image'
    },
    'svisionLogo': {
      fieldName: 'svisionLogo',
      label: 'Single Vision Logo (G)',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 100, unit: 'kB' },
      resolution: '900x200 px',
      category: 'mimesys',
      type: 'image'
    },
    'progressiveLogo': {
      fieldName: 'progressiveLogo',
      label: 'Progressive Logo (E)',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 100, unit: 'kB' },
      resolution: '900x200 px',
      category: 'mimesys',
      type: 'image'
    },
    //no se usa actualmente
    'officeLogo': {
      fieldName: 'officeLogo',
      label: 'Office Logo (F)',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 100, unit: 'kB' },
      resolution: '900x200 px',
      category: 'mimesys',
      type: 'image'
    },
    'distributorLogo': {
      fieldName: 'distributorLogo',
      label: 'Distributor logo (A)',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 100, unit: 'kB' },
      resolution: '900x200 px',
      category: 'mimesys',
      type: 'image'
    },
    'logo1': {
      fieldName: 'logo1',
      label: 'Logo 1',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 100, unit: 'kB' },
      resolution: '900x200 px',
      category: 'mimesys',
      type: 'image'
    },
    'logo2': {
      fieldName: 'logo2',
      label: 'Pdf-Logo 2',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 100, unit: 'kB' },
      resolution: '900x200 px',
      category: 'mimesys',
      type: 'image'
    },
    'logo3': {
      fieldName: 'logo3',
      label: 'Pdf-Logo 3',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 100, unit: 'kB' },
      resolution: '900x200 px',
      category: 'mimesys',
      type: 'image'
    },
    'coverImage': {
      fieldName: 'coverImage',
      label: 'Cover image (4)',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 1, unit: 'MB' },
      resolution: '1240x1748 px',
      category: 'mimesys',
      type: 'image'
    },
    'insidePageImage': {
      fieldName: 'insidePageImage',
      label: 'Inside page image (5)',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 1, unit: 'MB' },
      resolution: '1240x1748 px',
      category: 'mimesys',
      type: 'image'
    },
    'ergoCorridorLogo': {
      fieldName: 'ergoCorridorLogo',
      label: 'Corridor Logo',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 100, unit: 'kB' },
      resolution: '900x200 px',
      category: 'mimesys',
      type: 'image'
    },
    'progressiveLogoSubmenu': {
      fieldName: 'progressiveLogoSubmenu',
      label: 'Progressive Logo Submenu',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 100, unit: 'kB' },
      resolution: '900x200 px',
      category: 'mimesys',
      type: 'image'
    },
    //no se usa actualmente
    'officeLogoSubmenu': {
      fieldName: 'officeLogoSubmenu',
      label: 'Office Logo Submenu',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 100, unit: 'kB' },
      resolution: '900x200 px',
      category: 'mimesys',
      type: 'image'
    },
    'svisionLogoSubmenu': {
      fieldName: 'svisionLogoSubmenu',
      label: 'Office Logo Submenu',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 100, unit: 'kB' },
      resolution: '900x200 px',
      category: 'mimesys',
      type: 'image'
    },
    'screenSaverVideo': {
      fieldName: 'screenSaverVideo',
      label: 'Results video',
      formats: ['.mp4'],
      maxSize: { value: 50, unit: 'MB' },
      resolution: '1920x1080 px',
      category: 'mimesys',
      type: 'video'
    },

    // ========== SETTINGS FIT/MADE4U ==========
    'fitmade4uLogo1': {
      fieldName: 'fitmade4uLogo1',
      label: 'Logo 1',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 100, unit: 'kB' },
      resolution: '900x200 px',
      category: 'fitmade4u',
      type: 'image'
    },
    'fitmade4uLogo2': {
      fieldName: 'fitmade4uLogo2',
      label: 'Logo 2',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 100, unit: 'kB' },
      resolution: '900x200 px',
      category: 'fitmade4u',
      type: 'image'
    },
    'logoA': {
      fieldName: 'logoA',
      label: 'App Logo (A)',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 100, unit: 'kB' },
      resolution: '1200x1200 px',
      category: 'fitmade4u',
      type: 'image'
    },
    'logoB': {
      fieldName: 'logoB',
      label: 'App Logo (B)',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 100, unit: 'kB' },
      resolution: '1200x1200 px',
      category: 'fitmade4u',
      type: 'image'
    },
    'fitmade4uScreensaverVideo': {
      fieldName: 'fitmade4uScreensaverVideo',
      label: 'Screensaver video',
      formats: ['.mp4'],
      maxSize: { value: 20, unit: 'MB' },
      resolution: '1200x800',
      category: 'fitmade4u',
      type: 'video'
    },

    // ========== SETTINGS 360Depict ==========
    'logoC': {
      fieldName: 'logoC',
      label: '360Depict Logo (C)',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 100, unit: 'kB' },
      resolution: '900x200 px',
      category: '360',
      type: 'image'
    },
    'depict360Logo': {
      fieldName: 'depict360Logo',
      label: '360Depict Logo (C)',
      formats: ['.png', '.jpg', '.jpeg'],
      maxSize: { value: 100, unit: 'kB' },
      resolution: '900x200 px',
      category: '360',
      type: 'image'
    },
    'vertexDistance': {
      fieldName: 'vertexDistance',
      label: 'Vertex Distance',
      min: 5,
      max: 25
    },
    'pantoscipicAngle': {
      fieldName: 'pantoscipicAngle',
      label: 'Pantoscipic Angle',
      min: -5,
      max: 25
    }
  };

  constructor() { }

  /**
   * Convierte un tamaño a bytes según su unidad
   */
  private sizeToBytes(value: number, unit: 'B' | 'kB' | 'MB'): number {
    switch (unit) {
      case 'B':
        return value;
      case 'kB':
        return value * 1024;
      case 'MB':
        return value * 1024 * 1024;
    }
  }

  /**
   * Obtiene las especificaciones de un campo específico
   */
  getSpec(fieldName: string): FileSpec | undefined {
    return this.specs[fieldName];
  }


  //por si se necesitan en el futuro (validacion, por ejemplo)
  /**
   * Obtiene todas las especificaciones de una categoría
   */
  getSpecsByCategory(category: 'web' | 'mimesys' | 'fitmade4u' | '360'): FileSpec[] {
    return Object.values(this.specs).filter(spec => spec.category === category);
  }

  /**
   * Obtiene todas las especificaciones
   */
  getAllSpecs(): { [key: string]: FileSpec } {
    return this.specs;
  }

  /**
   * Valida si un archivo cumple con las especificaciones
   */
  validateFile(fieldName: string, file: File): { valid: boolean; errors: string[] } {
    const spec = this.getSpec(fieldName);

    if (!spec) {
      return { valid: false, errors: ['Field specification not found'] };
    }

    const errors: string[] = [];

    // Validar extensión
    const fileExtension = '.' + file.name.split('.').pop()?.toLowerCase();
    if (spec.formats && !spec.formats.includes(fileExtension)) {
      errors.push(`Invalid format. Allowed formats: ${spec.formats.join(', ')}`);
    }

    // Validar tamaño
    if (spec.maxSize) {
      const maxSizeBytes = this.sizeToBytes(spec.maxSize.value, spec.maxSize.unit);
      if (file.size > maxSizeBytes) {
        errors.push(`File too large. Maximum size: ${spec.maxSize.value} ${spec.maxSize.unit}`);
      }
    }

    return {
      valid: errors.length === 0,
      errors
    };
  }

  /**
   * Obtiene las extensiones permitidas como array para usar en validadores
   */
  getAllowedExtensions(fieldName: string): string[] {
    const spec = this.getSpec(fieldName);
    return spec ? spec.formats || [] : [];
  }

  /**
   * Obtiene el tamaño máximo en bytes
   */
  getMaxSizeBytes(fieldName: string): number {
    const spec = this.getSpec(fieldName);
    return spec && spec.maxSize ? this.sizeToBytes(spec.maxSize.value, spec.maxSize.unit) : 0;
  }

  /**
   * Valida un archivo y actualiza el estado del control de formulario
   * @param fieldName - Nombre del campo a validar
   * @param file - Archivo a validar
   * @param control - Control del formulario a actualizar
   * @param inputElement - (Opcional) Elemento input para limpiar si la validación falla
   * @returns true si el archivo es válido, false en caso contrario
   */
  validateAndSetFormControl(
    fieldName: string,
    file: File,
    control: AbstractControl,
    inputElement?: HTMLInputElement
  ): boolean {
    const result = this.validateFile(fieldName, file);
    control.markAsTouched();

    if (!result.valid) {
      control.setErrors({ fileValidation: result.errors });
      if (inputElement) {
        inputElement.value = '';
      }
      return false;
    }

    control.setErrors(null);
    return true;
  }

}
